module.exports = __webpack_public_path__ + "static/media/sx.3a548eed.svg";